import { createSlice } from '@reduxjs/toolkit';

/**
 * BackStack 아이템 구조:
 * {
 *   id: string,         // 고유 ID
 *   type: string,       // 'page' | 'sheet' | 'dialog' | 'drawer' | 'snackbar' | 'custom'
 *   path?: string,      // type: 'page' 일 때 이전 경로 저장
 *   handlerKey?: string // type: 'page' 외 나머지에서 사용
 * }
 */

const initialState = {
  stack: [],
  isProcessing: false,
};

const BackInfoSlice = createSlice({
  name: 'backInfo',
  initialState,
  reducers: {
    push(state, action) {
      state.stack.push(action.payload);
    },
    pop(state) {
      state.stack.pop();
    },
    removeById(state, action) {
      state.stack = state.stack.filter((item) => item.id !== action.payload);
    },
    clear(state) {
      state.stack = [];
    },
    setProcessing(state, action) {
      state.isProcessing = action.payload;
    },
    popPage(state) {
      for (let i = state.stack.length - 1; i >= 0; i--) {
        if (state.stack[i].type === 'page') {
          state.stack.splice(i, 1);
          break;
        }
      }
    },
  },
});

export const BackInfoActions = BackInfoSlice.actions;
export default BackInfoSlice.reducer;
